export default __webpack_public_path__ + "static/media/element_91.2d4daa57.jpg";